import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import { bindActionCreators } from "redux";
import { openRequestModal } from "../actions/modals";
import { withTranslation } from "react-i18next";
import DashLayout from "../layout/Dash";

class ProtectedRoute extends Component {
  render() {
    const Component = this.props.component;
    const path = this.props.path;
    return (
      <Route
        path={path}
        render={(props) => {
          return (
            <DashLayout {...props}>
              <Component {...props} />
            </DashLayout>
          );
        }}
      />
    );
  }
}

const widthConnect = connect(
  (state) => ({}),
  (dispatch) => bindActionCreators({ openRequestModal }, dispatch)
);
export default withTranslation()(widthConnect(ProtectedRoute));
